import * as stylex from "@stylexjs/stylex";
import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";
import { Eyebrow } from "@/ui/Eyebrow";
import { Icon } from "@/ui/Icon";
export function CueEyebrow({
  children
}: {
  children: ReactNode;
}) {
  return <span className="x78zum5 x6s0dn4 x17d4w8g">
      <Eyebrow>{children}</Eyebrow>
      <span className="x78zum5">
        <Icon icon={ChevronRight} size={16} strokeWidth={2} />
      </span>
    </span>;
}